module.exports = __webpack_public_path__ + "img/26.5bcd318c.png";